import { connect } from "react-redux";
import { fetchDataCount, fetchDataFolder  } from "../actions/datafolder";
import DataFolder from "../components/DataFolder/DataFolder";
import { fetchSearchData } from "../actions/documentsearchbar";

const mapStateToProps = (state) => ({
    user: state.login.user,
    count: state.datafolder.count,
    keys: state.datafolder.keys,
    headers: state.datafolder.headers,
    data: state.datafolder.data,
    isFetching: state.datafolder.isFetching,
    isFetchingCount: state.datafolder.isFetchingCount,
    menuData: state.menu.menuData,

    searchData: state.documentsearchbar.data,
    searchCount: state.documentsearchbar.count,
});

const mapDispatchToProps = {
    fetchDataCount,
    fetchDataFolder,
    fetchSearchData,
};

export default connect(mapStateToProps, mapDispatchToProps)(DataFolder);
